import { getAppMetadata } from '@/plan/metadata/metadata'
import {
  getTilesetFullNameFor,
  getConnection,
  isAudiencesQuintileEnabled,
} from '@/plan/metadata/metadata.helper'
import { vectorTilesetSource } from '@deck.gl/carto'
import { QuietVectorTileLayer } from '@/layers/quiet-vector-tile-layer'
import { AuthManager, buildSqlClientIdentifier } from '@workspaces/services'
import BrowserEnvironmentResolver from '@/helpers/environment.helper'
import { AUDIENCES_QUINTILE_TILESET_LAYER } from '../constant'
import { DataFilterExtension } from '@deck.gl/extensions'
import { getZIndexValueForLayer } from '../layers-z-index.helper'
// import { UpdateParameters } from '@deck.gl/core'

const appMetadata = getAppMetadata()
const browserEnvironmentResolver = BrowserEnvironmentResolver.getInstance()

const tileset = isAudiencesQuintileEnabled(appMetadata)
  ? appMetadata.data_model.audiences_quintile?.tileset
  : 'noTilesetSetForAudiencesQuintile'
if (!tileset) {
  throw new Error('Tileset not found for Audiences Quitile in app metadata')
}

// deck.gl 9: build the tileset CARTO source with the live access token and pass
// it as the VectorTileLayer `data`. Lazy so the token is available at call time.
export function buildAudiencesQuintileTilesetSource() {
  return vectorTilesetSource({
    accessToken: AuthManager.getInstance().getToken(),
    apiBaseUrl: appMetadata.base_url,
    connectionName: getConnection(appMetadata, browserEnvironmentResolver),
    clientId: buildSqlClientIdentifier(appMetadata, browserEnvironmentResolver),
    tableName: getTilesetFullNameFor(
      appMetadata,
      browserEnvironmentResolver,
      // `tileset` is guarded by the module-load throw above, so it is defined here.
      tileset as string,
    ),
  })
}

class AudiencesQuintileLayer extends QuietVectorTileLayer {
  // shouldUpdateState({ changeFlags }: UpdateParameters<this>): boolean {
  //   console.debug('shouldUpdateState', changeFlags)
  //   if (changeFlags.somethingChanged) {
  //     console.debug('shouldUpdateState  --> YES', changeFlags)
  //   }
  //   return changeFlags.somethingChanged
  // }
  // updateState(params: UpdateParameters<this>) {
  //   console.log('updateState', params)
  //   const { props, changeFlags } = params
  //   if (changeFlags.dataChanged) {
  //     console.log('updateState', changeFlags)
  //   }
  //   console.log('updateState     222222       state:\n', this.state)
  //   super.updateState(params)
  // }
}

AudiencesQuintileLayer.layerName = AUDIENCES_QUINTILE_TILESET_LAYER
AudiencesQuintileLayer.defaultProps = {}

export const propsForAudiencesQuintileLayer = {
  id: AUDIENCES_QUINTILE_TILESET_LAYER,
  layerType: AudiencesQuintileLayer,
  pickable: false,
  minZoom: 3,
  maxZoom: 19,
  tileSize: 512,
  visible: true,
  filled: true,
  stroked: true,
  getPolygonOffset: () =>
    getZIndexValueForLayer(AUDIENCES_QUINTILE_TILESET_LAYER),
  extensions: [new DataFilterExtension({ filterSize: 1 })],
  filterRange: [1, 1],
}
